import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PropiedadesRuralesService = /** @class */ (function () {
    function PropiedadesRuralesService(httpClient) {
        this.httpClient = httpClient;
        this.baseUrl = environment.baseUrl;
    }
    PropiedadesRuralesService.prototype.getPropiedadRural = function (id) {
        return this.httpClient.get(this.baseUrl + '/propiedades-rurales/' + id);
    };
    PropiedadesRuralesService.prototype.getPropiedadesRurales = function () {
        return this.httpClient.get(this.baseUrl + '/propiedades-rurales');
    };
    PropiedadesRuralesService.prototype.getDepartamentos = function () {
        return this.httpClient.get(this.baseUrl + '/departamentos');
    };
    PropiedadesRuralesService.ngInjectableDef = i0.defineInjectable({ factory: function PropiedadesRuralesService_Factory() { return new PropiedadesRuralesService(i0.inject(i1.HttpClient)); }, token: PropiedadesRuralesService, providedIn: "root" });
    return PropiedadesRuralesService;
}());
export { PropiedadesRuralesService };
